/* eslint-disable no-param-reassign */

export default function organizeJobsIntoDepartments(jobs) {
  return jobs.reduce((carry, currentValue) => {
    (carry[currentValue.department] =
      carry[currentValue.department] || []).push(currentValue);
    return carry;
  }, {});
}
